<template>
  <div style="padding-top: 1.6rem; padding-left: 0.6rem">
    <el-table :data="users" style="width: 100%" border>
      <el-table-column prop="content" label="提醒/通知内容"></el-table-column>
      <el-table-column prop="sender" label="发送人"></el-table-column>
      <el-table-column prop="receiver" label="接收人"></el-table-column>
      <el-table-column prop="sendTime" label="发送时间"></el-table-column>
      <el-table-column prop="relatedTask" label="相关任务或项目"></el-table-column>
      <el-table-column label="操作" width="130" fixed="right">
        <template slot-scope="scope">
          <div class="operation">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top">
              <el-button type="text" size="medium">编辑</el-button>
            </el-tooltip>
            <el-dropdown
              trigger="click"
              style="margin-left: 0.4rem; top: 0.04rem; cursor: pointer; color: #409eff"
            >
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown"></el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "SoftAuthor",
  data() {
    return {
      users: [
        {
          content: "明天有重要会议，请准时参加",
          sender: "张兰心",
          receiver: "胡春艳",
          sendTime: "2024-03-25 09:00:00",
          relatedTask: "投资项目"
        },
        {
          content: "下周需提交报告，请提前准备",
          sender: "魏震旗",
          receiver: "冯小雨",
          sendTime: "2024-03-26 10:30:00",
          relatedTask: "勘察报告"
        },
        {
          content: "提醒完成本周目标任务",
          sender: "言伟",
          receiver: "高伟卢",
          sendTime: "2024-03-27 14:00:00",
          relatedTask: "招标核验"
        },
        {
          content: "更新项目进度情况",
          sender: "smith",
          receiver: "陈阳",
          sendTime: "2024-03-28 11:45:00",
          relatedTask: "中期进度验收"
        },
        {
          content: "明天生日快乐！",
          sender: "唐淑燕",
          receiver: "齐琪",
          sendTime: "2024-03-29 08:00:00",
          relatedTask: "个人事务"
        },
        {
          content: "请审阅最新文档",
          sender: "卞婷婷",
          receiver: "陈思思",
          sendTime: "2024-03-30 15:20:00",
          relatedTask: "个人审批"
        },
        {
          content: "提醒参加团队活动",
          sender: "张燕",
          receiver: "刘文涛",
          sendTime: "2024-03-31 16:30:00",
          relatedTask: "团队建设"
        },
        {
          content: "安排下次会议时间地点",
          sender: "房凯",
          receiver: "毛文文",
          sendTime: "2024-04-01 13:10:00",
          relatedTask: "会议安排"
        }
      ]
    };
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/setting_panel/SoftAuthor.vue